import { configureStore } from '@reduxjs/toolkit';
import fatiaAutenticacaoReducer from './fatiaAutenticacao';
import fatiaEstabelecimentoReducer from './fatiaEstabelecimento';
import fatiaPainelControleReducer from './fatiaPainelControle';
import fatiaAdminReducer from './fatiaAdmin';

/**
 * Configuração do store Redux central do NexoGourmet
 * Requisitos: 4, 5, 6, 7
 */
export const store = configureStore({
  reducer: {
    autenticacao: fatiaAutenticacaoReducer,
    estabelecimento: fatiaEstabelecimentoReducer,
    painelControle: fatiaPainelControleReducer,
    admin: fatiaAdminReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignora campos de data que podem ser objetos Date
        ignoredActions: [
          'painelControle/definirFiltros',
          'painelControle/carregarDadosPainel/pending',
          'painelControle/carregarDadosPainel/fulfilled',
        ],
        ignoredPaths: ['painelControle.filtros.data'],
      },
    }),
  devTools: import.meta.env.DEV,
});

export type EstadoRaiz = ReturnType<typeof store.getState>;
export type DespachoApp = typeof store.dispatch;
